import { render, staticRenderFns } from "./OccupationalList.vue?vue&type=template&id=0f0948f9"
import script from "./OccupationalList.vue?vue&type=script&lang=js"
export * from "./OccupationalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports